import React from "react";
import PropTypes from "prop-types";
// import { useStyles } from "./styles";
import ScrollableTabs from "../../../../components/TabPanel/index";
import {
  triggerFetchActivationDistributionTable,
  triggerActivationDistributionCsv,
} from "../../../../redux/actions/index";

export default function ActivationSalesDistribution(props) {
  const {
    activationDistributionModel: {
      secTilesMasterTxDtos: tilesDto = [],
      isSectionActive = "",
      sectionName,
    },
    timestamp,
    ...other
  } = props;
  if (isSectionActive === "Y") {
    if (tilesDto.length) {
      return (
        <ScrollableTabs
          sectionHeader={"Activation " + sectionName}
          section={sectionName}
          tabsDto={tilesDto}
          sortingProperty="tileId"
          sortingOrder="asc"
          tabVariant="fullWidth"
          color="#7caeea"
          triggerFetchActivationDistributionTable={
            triggerFetchActivationDistributionTable
          }
          triggerActivationDistributionCsv={triggerActivationDistributionCsv}
          timeStampArr={timestamp}
          {...other}
        />
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
}

ActivationSalesDistribution.propTypes = {
  tilesDto: PropTypes.arrayOf(
    PropTypes.shape({
      tileId: PropTypes.number,
      tileName: PropTypes.string,
      isTileActive: PropTypes.string,
      tileEndPointUrl: PropTypes.string,
      moduleSecMasterTransactionDto: PropTypes.any,
    })
  ),
};
